import { mountGame } from '../render/three/game-app.js';
import { freecellSpec } from '../variants/freecell/spec.js';

await mountGame(freecellSpec);
